/**
 * Normalise Contentful copy fields (HTML or Markdown) for {@link Markup}.
 *
 * @param {string|null|undefined} source
 * @returns {string}
 */
export function contentfulTextToMarkupSource(source) {
  if (source == null || typeof source !== 'string') return '';

  const trimmed = source.trim();

  if (!trimmed) return '';

  if (/<\/?[a-z][\s\S]*>/i.test(trimmed)) return trimmed;

  return contentfulMarkdownToHtml(trimmed);
}

function inlineContentfulMarkdown(text) {
  return text
    .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2">$1</a>')
    .replace(/__(.+?)__/g, '<strong>$1</strong>')
    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
    .replace(/\*(.+?)\*/g, '<em>$1</em>')
    .replace(/_(.+?)_/g, '<em>$1</em>');
}

function contentfulMarkdownToHtml(markdown) {
  const lines = markdown.split('\n');
  const html = [];
  let inList = false;

  for (const line of lines) {
    const trimmed = line.trim();

    if (!trimmed) {
      if (inList) {
        html.push('</ul>');
        inList = false;
      }
      continue;
    }

    if (trimmed.startsWith('- ')) {
      if (!inList) {
        html.push('<ul>');
        inList = true;
      }

      html.push(`<li>${inlineContentfulMarkdown(trimmed.slice(2))}</li>`);
      continue;
    }

    if (inList) {
      html.push('</ul>');
      inList = false;
    }

    html.push(`<p>${inlineContentfulMarkdown(trimmed)}</p>`);
  }

  if (inList) html.push('</ul>');

  return html.join('');
}
